import script from "./TableInfoDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableInfoDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./datastoreDrawers.scss?vue&type=style&index=0&id=6afb2908&lang=scss&scoped=true"
import "./TableInfoDrawer.vue?vue&type=style&index=1&id=6afb2908&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afb2908"]])

export default __exports__